import React from 'react';
import { offeringCategory } from '../../helpers/mappings';
import './index.css';

const ComingSoonLabel = ({ offering }) => {
  const { category, status } = offering;
  let label = null;
  if ((category === offeringCategory.COMING_SOON.value || category === offeringCategory.TESTING_WATERS.value) && status === 'active') {
    label = (<span styleName="comingSoonLabel">Coming Soon</span>);
  }
  return label;
};

export default ComingSoonLabel;



// WEBPACK FOOTER //
// ./src/components/ComingSoonLabels/index.js